import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const VISITOR_KEY = "nf_visitor_id";

function getVisitorId() {
  let v = localStorage.getItem(VISITOR_KEY);
  if (!v) {
    v = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(VISITOR_KEY, v);
  }
  return v;
}

/**
 * Fires a visit ping to the backend on every route change.
 * Anonymous visitors get a localStorage-pinned visitor_id; logged-in users
 * are also linked because the auth header is automatically attached.
 */
export default function useVisitTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname || "/";
    const referrer = document.referrer || "";
    const visitor_id = getVisitorId();
    // Fire and forget — never block the UI on this
    axios
      .post(`${BACKEND_URL}/api/visits/ping`, { path, referrer, visitor_id })
      .catch(() => {});
  }, [location.pathname]);
}
